import React, { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=unauth, obj=auth
  const [loading, setLoading] = useState(true);

  const check = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      setUser(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    check();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      // Token is stored as httpOnly cookie by the server — do NOT persist in localStorage
      setUser(data);
      return { ok: true };
    } catch (e) {
      const status = e.response?.status;
      const body = e.response?.data;
      // slowapi (rate-limit) returns { error: "Rate limit exceeded..." } with 429
      // FastAPI HTTPException returns { detail: "..." } with 401/403/etc.
      let msg;
      if (status === 429) {
        msg = (typeof body?.error === "string" ? body.error : "") ||
              "Too many attempts. Please wait a minute and try again.";
      } else if (body?.detail != null) {
        msg = formatApiError(body.detail);
      } else if (typeof body?.error === "string") {
        msg = body.error;
      } else {
        msg = e.message || "Sign-in failed. Please try again.";
      }
      return { ok: false, error: msg };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    // Clear any legacy localStorage token if it exists
    localStorage.removeItem("nc_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh: check }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
